import { gql } from '../../../apollo/__generated__';

export const EVENTS = gql(`
  query Events {
    events {
      id
      name
      type
      arePaymentsEnabled
      areBedroomPaymentsEnabled
      description
      lydiaLink
      checkAddress
      maxUsers
      startAt
      endAt
      hasJoined
      waitingListPosition
      isTargetEnabled
      isTinderEnabled
      milestones {
        id
        isVoucherOnly
        name
        prices {
          day
          value
        }
        startAt
        endAt
      }
      place {
        id
      }
      validatedUsersCount
      paidTicketUsersCount
      paidBedroomUsersCount
      usersCount
      isFull
    }
  }
`);
